export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70418210aec66561d5da9aaa548104b0d5e0b23fab&name=pushAdClickData!'